/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_CopyInputs */

const en_shortcut_keys_desc_copy = /** @type {(inputs: Shortcut_Keys_Desc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy event or selected text`)
};

const fr_shortcut_keys_desc_copy = /** @type {(inputs: Shortcut_Keys_Desc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier l'evenement ou le texte selectionne`)
};

const de_shortcut_keys_desc_copy = /** @type {(inputs: Shortcut_Keys_Desc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis oder ausgewählten Text kopieren`)
};

const it_shortcut_keys_desc_copy = /** @type {(inputs: Shortcut_Keys_Desc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia l'evento o il testo selezionato`)
};

const ru_shortcut_keys_desc_copy = /** @type {(inputs: Shortcut_Keys_Desc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать событие или выделенный текст`)
};

const es_shortcut_keys_desc_copy = /** @type {(inputs: Shortcut_Keys_Desc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar evento o texto seleccionado`)
};

const zh_cn2_shortcut_keys_desc_copy = /** @type {(inputs: Shortcut_Keys_Desc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制事件或选定文本`)
};

const ja_shortcut_keys_desc_copy = /** @type {(inputs: Shortcut_Keys_Desc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントまたは選択したテキストをコピー`)
};

const hi_shortcut_keys_desc_copy = /** @type {(inputs: Shortcut_Keys_Desc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट या चयनित टेक्स्ट को कॉपी करें`)
};

const pt_pt2_shortcut_keys_desc_copy = /** @type {(inputs: Shortcut_Keys_Desc_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar evento ou texto selecionado`)
};

/**
* | output |
* | --- |
* | "Copy event or selected text" |
*
* @param {Shortcut_Keys_Desc_CopyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_copy = /** @type {((inputs?: Shortcut_Keys_Desc_CopyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_CopyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_copy(inputs)
	if (locale === "de") return de_shortcut_keys_desc_copy(inputs)
	if (locale === "it") return it_shortcut_keys_desc_copy(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_copy(inputs)
	if (locale === "es") return es_shortcut_keys_desc_copy(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_copy(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_copy(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_copy(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_copy(inputs)
	return en_shortcut_keys_desc_copy(inputs)
});